var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHybrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 75,
    viewBox: "0 0 69 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8021 2H4.16367C2.99722 2 2.07828 2.99414 2.16984 4.15699L6.89211 64.1298C6.9571 64.9552 7.52394 65.6552 8.31777 65.8904L33.4318 73.3316C33.8026 73.4415 34.1974 73.4415 34.5682 73.3316L59.7042 65.8839C60.4871 65.652 61.0503 64.9674 61.1271 64.1545L66.7932 4.18814C66.9041 3.01448 65.981 2 64.8021 2Z",
    stroke: "#DA8E34",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65.5V8.5H58.5L54.5 59L34 65.5Z",
    fill: "#FBD6A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.968 56V41.84H27.28V56H20.08V21.008H27.28V34.832H41.968V21.008H49.168V56H41.968Z",
    fill: "#DA8E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybrid);
export default __webpack_public_path__ + "static/media/Hybrid.aedf59e08a37fb44a9c5c68d50542273.svg";
export { ForwardRef as ReactComponent };